import { Component, ViewEncapsulation, Input, OnChanges, ViewChild } from '@angular/core';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/service/auth.service';
import { ConfigService } from 'src/app/service/config.service';
import { ColorPipe } from 'src/app/pipe/color.pipe';
import { MatDialog } from '@angular/material/dialog';
import { AnnotationComponent } from '../../news-annotation/news-annotation.component';
import { MatTabNav } from '@angular/material/tabs';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-count',
  templateUrl: './news-count.component.html',
  styleUrls: ['./news-count.component.scss']
})
export class NewsCountComponent implements OnChanges {

  @Input('newsfeedData') newsfeedData: any;

  @ViewChild(MatTabNav) public matTabNav: MatTabNav;

  params: any;
  // titolo$: Observable<YukkApi>
  previousValue: any;
  datacount: any;
  note$: Observable<any>;
  keyd: string;
  notes = [];
  iselect = true;
  ngxpie = {
    data: null,
    color: {
      domain: [
        this.colorpipe.transform(1),
        this.colorpipe.transform(.5),
        this.colorpipe.transform(0),
        this.colorpipe.transform(-1),
      ]
    },
  };
  moreinfo = false;
  onote = true;
  noise = true;
  duplicate: boolean;
  noSentiments: boolean;
  titleEntity: boolean;
  licensedContent: boolean;
  fadeout: boolean;
  dimmed: boolean;
  selectedOptions = ['en', 'de'];
  loading: boolean;
  newstype: string;
  navLinks = [];
  project: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private yukkApi: YukkApi,
    public routing: RoutingService,
    public auth: AuthService,
    public config: ConfigService,
    private colorpipe: ColorPipe,
    public dialog: MatDialog,
  ) {

    this.project = this.config.appConfig.routing.project;

    this.route.queryParams.subscribe(params => {

      if (this.routing.isNewsletter() && this.auth.newsletterParams) {
        this.params = this.auth.newsletterParams;
      } else {
        this.params = params;
      }

      this.noise = params.noise === 'true';
      this.licensedContent = params.license === 'true';
      this.duplicate = true;
      if (params.duplicate) {
        this.duplicate = params.duplicate === 'true';
      }
      this.noSentiments = false;
      this.titleEntity = params.title === 'true';
      this.fadeout = true;
      this.dimmed = true;
      if (this.routing.isScanner()) {
        this.navLinks = ['Stories', 'Chronological', 'Events'];
      } else if (params.type && ['hierarchy', 'industry', 'sector', 'supersector', 'subsector'].includes(params.type) && !this.routing.isNewsaudit()) {
        this.navLinks = ['Stories', 'Chronological', 'Bookmarked'];
      } else if (params.type && ['hierarchy', 'industry', 'sector', 'supersector', 'subsector'].includes(params.type) && this.routing.isNewsaudit()) {
        // this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        if (!this.auth.featureFlags.flaggingEnabled && !auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked'];
        } else if (!auth.featureFlags.flaggingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Dismissed'];
        } else if (!auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged'];
        } else {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        }
      } else if (!(this.routing.isQuery() || this.routing.isSearch()) && this.routing.isNewsaudit()) {
        // this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        if (!this.auth.featureFlags.flaggingEnabled && !auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked'];
        } else if (!auth.featureFlags.flaggingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Dismissed'];
        } else if (!auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged'];
        } else {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        }
      } else if ((this.routing.isQuery() || this.routing.isSearch()) && this.routing.isNewsaudit()) {
        // this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        if (!this.auth.featureFlags.flaggingEnabled && !auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked'];
        } else if (!auth.featureFlags.flaggingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Dismissed'];
        } else if (!auth.featureFlags.dismissingEnabled) {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged'];
        } else {
          this.navLinks = ['Chronological', 'Bookmarked', 'Flagged', 'Dismissed'];
        }
      } else if (this.routing.isQuery() || this.routing.isSearch()) {
        if (this.routing.isChart() || this.routing.isChart2()) {
          this.navLinks = ['Stories', 'Chronological', 'Bookmarked'];
        } else {
          this.navLinks = ['Stories', 'Chronological', 'Bookmarked'];
        }
      } else {
        // this.navLinks = ['Chronological', 'Bookmarked', 'Stories'];
        if (this.routing.isMobile()) {
          this.navLinks = ['Stories', 'Chronological', 'Events', 'Bookmarked'];
        } else {
          if ((this.routing.isChart() || this.routing.isChart2()) && (!this.routing.isFolio() || params?.portfolioId)) {
            this.navLinks = ['Stories', 'Chronological', 'Events', 'Bookmarked'];
          } else {
            this.navLinks = ['Stories', 'Chronological', 'Bookmarked'];
          }
        }
      }
      if (this.auth.noNewsfeedSentiments) {
        this.noSentiments = this.auth.noNewsfeedSentiments;
      }
      if (this.auth.noNewsfeedSentiments) {
        this.noSentiments = this.auth.noNewsfeedSentiments;
      }
      if (params.fadeout) {
        this.fadeout = params.fadeout === 'true';
      }
      if (params.dimmed) {
        this.dimmed = params.dimmed === 'true';
      }
      if (!params.news && params.newsday) {
        this.keyd = params.type + ':' + params.id;
        this.auth.getNote(this.keyd).subscribe(risp => {
          let newnote = [];
          if (risp.length) {
            newnote = risp.filter(item => item.position === params.newsday);
          }
          if (this.notes !== newnote) {
            this.notes = newnote;
          }
        });
      }
      if (params.note) {
        this.auth.getNoteByid(params.note).subscribe(risp => {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AnnotationComponent, {
            autoFocus: false,
            data: risp
          });
          dialogRef.afterClosed().subscribe(rosp => {
            this.router.navigate([], {
              queryParams: {
                note: null
              },
              queryParamsHandling: 'merge',
              replaceUrl: true
            });
          });
        });
      }

      if ((params.id || params.isin) && routing.reFresh(params, this.previousValue, ['update', 'updatePayload', 'type', 'id', 'isin', 'time', 'period', 'lang', 'feed', 'categories', 'continents', 'countries', 'ranks', 'tag', 'participant', 'newsday', 'newstype', 'eventid', 'event_ids', 'newsfeedFromQuery'])) {
        this.loading = true;
        this.params.newstype ? this.newstype = this.params.newstype : (this.routing.isNewsaudit()) ? this.newstype = 'Chronological' : this.newstype = 'Stories';
        if (/*(this.routing.isScanner() || this.routing.isMobile()) && */!this.params.newstype) {
          // this.newstype = 'Stories';
        }
        if (this.newstype === 'Chronological') {
          if (!this.params.title) {
            this.titleEntity = false;
          }
          if (!this.params.license) {
            this.licensedContent = false;
          }
        } else if (this.newstype === 'Events') {
          if (!this.params.title) {
            this.titleEntity = false;
          }
          if (!this.params.license) {
            this.licensedContent = false;
          }
        } else if (this.newstype === 'Stories') {
          if (!this.params.title) {
            this.titleEntity = false;
          }
          if (!this.params.license) {
            this.licensedContent = false;
          }
        } else {
          if (!this.params.title) {
            this.titleEntity = false;
          }
          if (!this.params.license) {
            this.licensedContent = false;
          }
          if (!this.params.duplicate) {
            this.duplicate = false;
          }
        }
      }
      this.previousValue = params;

    });

  }

  ngOnChanges() {

    if (this.newsfeedData) {
      this.injectNewsfeed(this.newsfeedData);
    } else {
      this.loading = true;
    }

    setTimeout(() => {
      if (this.matTabNav) {
        this.matTabNav._alignInkBarToSelectedTab();
      }
    }, 500);

  }

  injectNewsfeed(result) {
    this.params.newstype ? this.newstype = this.params.newstype : (this.routing.isNewsaudit()) ? this.newstype = 'Chronological' : this.newstype = 'Stories';
    if (/*(this.routing.isScanner() || this.routing.isMobile()) && */!this.params.newstype) {
      // this.newstype = 'Stories';
    }
    if (this.newstype === 'Chronological') {
      if (!this.params.title) {
        this.titleEntity = false;
      }
      if (!this.params.license) {
        this.licensedContent = false;
      }
    } else if (this.newstype === 'Events') {
      if (!this.params.title) {
        this.titleEntity = false;
      }
      if (!this.params.license) {
        this.licensedContent = false;
      }
    } else if (this.newstype === 'Stories') {
      if (!this.params.title) {
        this.titleEntity = false;
      }
      if (!this.params.license) {
        this.licensedContent = false;
      }
    } else {
      if (!this.params.title) {
        this.titleEntity = false;
      }
      if (!this.params.license) {
        this.licensedContent = false;
      }
      if (!this.params.duplicate) {
        this.duplicate = false;
      }
    }

    if (result.news_after == null) {
      this.datacount = undefined;
    } else {
      this.datacount = {
        positiv: result.sentiment_counts.pos,
        neutral: result.sentiment_counts.neu,
        negativ: result.sentiment_counts.neg,
        total: result.news_total_count
      };
      this.ngxpie.data = [
        {
          'name': 'Positive',
          'value': this.datacount.positiv
        },
        {
          'name': 'Neutral',
          'value': this.datacount.neutral
        },
        {
          'name': 'Negative',
          'value': this.datacount.negativ
        },
      ];
    }
    this.loading = false;
  }

  inFilter(event) {
    // if (event === 'Positive') { event = 'pos'; }
    // if (event === 'Neutral') { event = 'neu'; }
    // if (event === 'Negative') { event = 'neg'; }
    // if (this.params.filter === event || event === 'all') {
    //   this.router.navigate([], {
    //     queryParams: { tag: null, filter: null },
    //     queryParamsHandling: 'merge',
    //     replaceUrl: false
    //   });
    // } else {
    //   this.router.navigate([], {
    //     queryParams: { tag: null, filter: event },
    //     queryParamsHandling: 'merge',
    //     replaceUrl: false
    //   });
    // }
  }

  allNote() {
    this.router.navigate([], {
      queryParams: { allnote: !this.params.allnote ? 'true' : null },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  newNote() {
    this.dialog.open(AnnotationComponent, {
      autoFocus: false,
      // panelClass: 'panelAnnotation',
      data: {
        newone: true,
        entity: this.params.type + ':' + this.params.id,
        newsday: this.params.newsday
      }
    });
  }

  outNote() {
    this.router.navigate([], {
      queryParams: {
        note: null,
        newsday: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  isActive(event) {
    if (!this.params.filter || (event === 'pos' && this.params.filter === 'pos')) { return true; }
    if (!this.params.filter || (event === 'neu' && this.params.filter === 'neu')) { return true; }
    if (!this.params.filter || (event === 'neg' && this.params.filter === 'neg')) { return true; }
    return false;
  }

  getType(entity) {
    return entity.split(':')[0];
  }

  getId(entity) {
    return entity.split(':')[1];
  }

  getTooltip(tab) {
    if (tab === 'Events') {
      return 'Events excerpts from the articles';
    } else if (tab === 'Stories') {
      return 'Articles grouped in stories';
    } else if (tab === 'Chronological') {
      return 'Articles sorted by latest date and time';
    } else if (tab === 'Bookmarked') {
      return 'Articles that you’ve saved';
    } else if (tab === 'Flagged') {
      return 'Articles flagged for action';
    } else if (tab === 'Dismissed') {
      return 'Dismissed articles';
    }
  }

  linkNote(note) {
    this.router.navigate([], {
      queryParams: {
        note: note.uid,
        type: note.entity.split(':')[0],
        id: note.entity.split(':')[1],
        newsday: note.position,
        news: null
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  isNoise(value) {
    this.router.navigate([], {
      queryParams: {
        noise: value
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  isLicensedContent(value) {
    this.router.navigate([], {
      queryParams: {
        license: value
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  isPress(value) {
    this.router.navigate([], {
      queryParams: {
        project: value ? 'pressrelations' : null
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    }).then(() => {
      location.reload();
    });
  }

  isDupli() {
    this.router.navigate([], {
      queryParams: {
        duplicate: this.duplicate
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  changeNoSentiments() {
    this.auth.noNewsfeedSentiments = this.noSentiments;
    const newCustomSettings = Object.assign({}, this.auth.cockpitSettings, {
      noNewsfeedSentiments: this.noSentiments
    });
    this.auth.cockpitSettings = newCustomSettings;
    this.auth.setCustomSettings(newCustomSettings).subscribe();
  }

  isTitleEntity() {
    this.router.navigate([], {
      queryParams: {
        title: this.titleEntity
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  fadeoutSeen() {
    this.router.navigate([], {
      queryParams: {
        fadeout: this.fadeout
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  dimResolved() {
    this.router.navigate([], {
      queryParams: {
        dimmed: this.dimmed
      },
      queryParamsHandling: 'merge',
      replaceUrl: false
    });
  }

  onNgModelChange() {
  }

  changeNews(value) {
    if ((value !== 'Events') && ((this.params.newstype === 'Events') || (this.newstype === 'Events'))) {
      this.router.navigate([], {
        queryParams: {
          newstype: value,
          eventsFromScanner: null
          // eventid: null,
          // eventype: null,
        },
        queryParamsHandling: 'merge',
        replaceUrl: false
      });
    } else {
      this.router.navigate([], {
        queryParams: {
          newstype: value,
          eventsFromScanner: (this.routing.isScanner() && (value === 'Events')) ? 'true' : null
        },
        queryParamsHandling: 'merge',
        replaceUrl: false
      });
    }
  }

  renameTab(name) {
    if (name === 'Chronological') {
      return 'All News';
    } else {
      return name;
    }
  }


}
